import type { BookingCategoryClass } from '@/features/booking/types/bookingTypes';

/**
 * SVG Badge icons for each tier
 */
const tierBadges = {
    Diamond: `<svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 342 235" fill="currentColor">
	<path fill-rule="evenodd" d="m26.56 111.45q2.3 12.8 8.05 19.21 7.06 7.55 20.2 7.22-26.61 1.81-27.43 26.44-2.79-26.6-27.25-25.62 13.3-2.13 19.37-7.39 7.88-6.56 7.06-19.86zm234.15-91.95q15.6 18.22 33.66 47.29 10.01 16.09 10.01 16.41 0 3.29-14.61 21.02-17.73 21.35-49.09 56.32-34.82 38.59-50.08 56.65-14.62 17.08-17.41 17.24-4.6 0.33-19.05-16.42-16.58-19.21-49.42-56.48-31.69-36.13-49.91-57.31-14.46-16.75-14.62-20.19-0.33-5.42 8.21-16.92 2.3-2.95 6.73-8.54 4.11-4.76 5.09-6.4 4.76-6.89 10.35-15.76 6.4-10.34 9.69-15.11 32.83-2.46 89.15-2.13 75.2 0.66 91.3 0.33zm-175.86 21.83q-3.45 5.59-11.49 17.24-7.55 11.01-11.33 17.41h46.47q-20.53-31.69-23.65-34.65zm-3.61 127.42q2.63 16.75 17.24 16.42-8.37 1.81-11.98 4.93-4.93 4.1-4.44 12.48-2.46-8.54-5.42-11.83-4.43-5.25-12.8-4.6 17.07-2.78 17.4-17.4zm-16.42-77.34q69.95 81.78 87.52 99.34-7.23-18.88-17.57-49.42-13.96-40.88-17.08-49.92-7.39-0.16-25.28 0-19.38 0-27.59 0zm35.47-57.46q3.77 7.39 11.16 18.55 8.87 12.97 11.66 17.9 15.11-14.29 31.85-36.45zm72.91 168.63q4.76-16.92 18.88-56.49 12.81-35.63 17.57-55.66-13.3 1.31-38.42 1.15-31.36-0.33-37.11-0.17 31.03 92.29 39.08 111.17zm31.03-127.58q-4.11-4.27-16.25-18.4-9.86-11.65-16.59-18.06-4.43 6.24-15.6 18.56-10.67 11.66-15.43 18.88 5.74-0.16 32.51 0 20.03 0.33 31.36-0.98zm-14.61-41.05q14.61 21.02 31.85 36.45 2.79-5.59 11.66-18.56 8.04-11.49 10.18-17.89zm81.11 69.29q7.88-8.87 7.23-12.81-7.06 1.15-24.3 0.98-23.81-0.16-27.59 0-4.43 15.6-16.91 50.74-11.5 32.18-15.93 49.42 17.9-21.34 77.5-88.33zm-34.64-27.26q4.1-0.16 23.81 0 14.77 0.33 22.66-0.98-3.78-4.44-11.99-17.08-7.39-11.17-12.65-16.59-21.51 34.16-21.83 34.65zm41.87 79.14q2.46 7.72 4.27 10.51 4.43 6.41 12.15 5.09-8.87 3.61-11.17 5.58-5.09 4.44-4.27 12.65-3.28-16.75-17.4-17.41 16.09-2.29 16.42-16.42zm63.87-131.19q-12.65 2.96-17.9 6.9-7.55 5.91-6.73 17.73-2.96-11.16-6.9-16.25-5.58-7.23-15.92-7.39 22-3.12 21.01-24.63 3.12 12.31 7.56 17.4 6.4 7.39 18.88 6.24z"/>
</svg>`,
    Platinum: `<svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="10,60 25,20 35,55" />
                        <polygon points="35,55 50,5 65,55" />
                        <polygon points="65,55 75,20 90,60" />
                        <ellipse cx="33" cy="52" rx="4" ry="8" fill="rgba(0,0,0,0.3)" />
                        <ellipse cx="67" cy="52" rx="4" ry="8" fill="rgba(0,0,0,0.3)" />
                        <polygon points="10,55 10,70 90,70 90,55 75,50 50,55 25,50" />
                        <rect x="8" y="75" width="84" height="15" rx="4" ry="4" />
                    </svg>`,
    Gold: `<svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <polygon points="50,8 42,22 50,36 58,22" />
                        <circle cx="50" cy="8" r="5" />
                        <path d="M25,35 Q15,25 10,35 Q5,50 20,45 Q30,42 30,35 Q30,28 25,35" />
                        <circle cx="25" cy="38" r="5" />
                        <path d="M75,35 Q85,25 90,35 Q95,50 80,45 Q70,42 70,35 Q70,28 75,35" />
                        <circle cx="75" cy="38" r="5" />
                        <polygon points="5,30 15,55 25,40" />
                        <polygon points="95,30 85,55 75,40" />
                        <polygon points="15,45 15,70 85,70 85,45 75,50 50,35 25,50" />
                        <polygon points="50,48 44,58 50,68 56,58" fill="rgba(0,0,0,0.3)" />
                        <rect x="10" y="78" width="80" height="12" />
                    </svg>`,
    Silver: `<svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M55,15 C60,40 65,45 90,50 C65,55 60,60 55,85 C50,60 45,55 20,50 C45,45 50,40 55,15 Z" />
                        <path d="M20,10 C22,20 25,22 35,25 C25,28 22,30 20,40 C18,30 15,28 5,25 C15,22 18,20 20,10 Z" />
                        <path d="M80,65 C82,75 85,77 95,80 C85,83 82,85 80,95 C78,85 75,83 65,80 C75,77 78,75 80,65 Z" />
                    </svg>`,
    Bronze: `<svg width="100" height="100" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path d="M50,10 C50,10 70,40 55,55 L45,55 C30,40 50,10 50,10" fill="currentColor" />
                        <path d="M50,10 C50,10 60,40 50,55 C40,40 50,10 50,10" fill="currentColor" />
                        <path d="M45,55 C30,55 10,45 10,30 C10,20 25,20 30,30 C35,40 45,55 45,55" fill="currentColor" />
                        <circle cx="10" cy="30" r="4" fill="rgba(0,0,0,0.2)" />
                        <path d="M55,55 C70,55 90,45 90,30 C90,20 75,20 70,30 C65,40 55,55 55,55" fill="currentColor" />
                        <circle cx="90" cy="30" r="4" fill="rgba(0,0,0,0.2)" />
                        <rect x="35" y="53" width="30" height="8" rx="2" fill="currentColor" fill-opacity="0.9" />
                        <path d="M50,85 C50,85 30,65 40,58 L60,58 C70,65 50,85 50,85" fill="currentColor" />
                        <path d="M40,58 Q30,70 20,65" stroke="currentColor" stroke-width="3" fill="none" />
                        <path d="M60,58 Q70,70 80,65" stroke="currentColor" stroke-width="3" fill="none" />
                    </svg>`,
    Standard: '',
};

/**
 * Style configuration for each booking category ticket card
 */
export interface TicketCategoryStyle {
    /** Background gradient CSS */
    backgroundGradient: string;
    /** Border color for the card */
    borderColor: string;
    /** Hover border color */
    hoverBorderColor: string;
    /** Accent text color (for category label, icons) */
    accentColor: string;
    /** Primary text color */
    textColor: string;
    /** Secondary/muted text color */
    secondaryTextColor: string;
    /** Icon for category label (sparkle for premium) */
    categoryIcon: string;
    /** Shadow/glow color for hover effects */
    glowColor: string;
    /** Ring color for focus state */
    focusRingColor: string;
    /** Background color for circular cutouts */
    cutoutBgColor: string;
    /** Stub text color */
    stubTextColor: string;
    /** Dashed border color */
    dashedBorderColor: string;
    /** SVG badge for the tier */
    badgeSvg: string;
    /** Button gradient for CTA buttons */
    buttonGradient: string;
    /** Button text color */
    buttonTextColor: string;
}

/**
 * Category styles configuration
 */
const categoryStyles: Record<BookingCategoryClass, TicketCategoryStyle> = {
    Diamond: {
        backgroundGradient: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 30%, #0f3460 60%, #1a1a2e 100%)',
        borderColor: '#74c0fc',
        hoverBorderColor: '#a5d8ff',
        accentColor: '#ffffff',
        textColor: '#ffffff',
        secondaryTextColor: '#a5d8ff',
        categoryIcon: '◆',
        glowColor: 'rgba(116, 192, 252, 0.25)',
        focusRingColor: '#74c0fc',
        cutoutBgColor: '#0a0a14',
        stubTextColor: '#ffffff',
        dashedBorderColor: 'rgba(116, 192, 252, 0.4)',
        badgeSvg: tierBadges.Diamond,
        buttonGradient: 'linear-gradient(135deg, #4fc3f7 0%, #29b6f6 50%, #03a9f4 100%)',
        buttonTextColor: '#0a0a14',
    },
    Platinum: {
        backgroundGradient: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 30%, #404040 60%, #1a1a1a 100%)',
        borderColor: '#868e96',
        hoverBorderColor: '#c0c0c0',
        accentColor: '#ffffff',
        textColor: '#ffffff',
        secondaryTextColor: '#c0c0c0',
        categoryIcon: '♕',
        glowColor: 'rgba(192, 192, 192, 0.2)',
        focusRingColor: '#868e96',
        cutoutBgColor: '#0a0a0a',
        stubTextColor: '#ffffff',
        dashedBorderColor: 'rgba(134, 142, 150, 0.4)',
        badgeSvg: tierBadges.Platinum,
        buttonGradient: 'linear-gradient(135deg, #e0e0e0 0%, #bdbdbd 50%, #9e9e9e 100%)',
        buttonTextColor: '#1a1a1a',
    },
    Gold: {
        backgroundGradient: 'linear-gradient(135deg, #7a5c00 0%, #8b6914 10%, #a67c00 25%, #b8860b 40%, #c9a020 50%, #b8860b 60%, #a67c00 75%, #8b6914 90%, #7a5c00 100%)',
        borderColor: '#ffc107',
        hoverBorderColor: '#ffeb3b',
        accentColor: '#ffffff',
        textColor: '#ffffff',
        secondaryTextColor: '#f0e6cc',
        categoryIcon: '👑',
        glowColor: 'rgba(255, 193, 7, 0.3)',
        focusRingColor: '#b8860b',
        cutoutBgColor: '#1a1a2e',
        stubTextColor: '#ffffff',
        dashedBorderColor: 'rgba(255, 255, 255, 0.3)',
        badgeSvg: tierBadges.Gold,
        buttonGradient: 'linear-gradient(135deg, #ffd54f 0%, #ffca28 50%, #ffb300 100%)',
        buttonTextColor: '#4a3600',
    },
    Silver: {
        backgroundGradient: 'linear-gradient(135deg, #4a4a4a 0%, #6b6b6b 30%, #8b8b8b 60%, #4a4a4a 100%)',
        borderColor: '#c0c0c0',
        hoverBorderColor: '#e8e8e8',
        accentColor: '#ffffff',
        textColor: '#ffffff',
        secondaryTextColor: '#e0e0e0',
        categoryIcon: '✦',
        glowColor: 'rgba(173, 181, 189, 0.2)',
        focusRingColor: '#868e96',
        cutoutBgColor: '#1a1a1a',
        stubTextColor: '#e0e0e0',
        dashedBorderColor: 'rgba(134, 142, 150, 0.4)',
        badgeSvg: tierBadges.Silver,
        buttonGradient: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 50%, #bdbdbd 100%)',
        buttonTextColor: '#2d2d2d',
    },
    Bronze: {
        backgroundGradient: 'linear-gradient(135deg, #5c3317 0%, #8b4513 30%, #cd7f32 60%, #8b4513 100%)',
        borderColor: '#e67e22',
        hoverBorderColor: '#f39c12',
        accentColor: '#ffeedd',
        textColor: '#ffffff',
        secondaryTextColor: '#ffeedd',
        categoryIcon: '✤',
        glowColor: 'rgba(205, 127, 50, 0.25)',
        focusRingColor: '#a0522d',
        cutoutBgColor: '#1a1a1a',
        stubTextColor: '#ffeedd',
        dashedBorderColor: 'rgba(255, 238, 221, 0.3)',
        badgeSvg: tierBadges.Bronze,
        buttonGradient: 'linear-gradient(135deg, #ffcc80 0%, #ffb74d 50%, #ff9800 100%)',
        buttonTextColor: '#4a2800',
    },
    Standard: {
        backgroundGradient: 'linear-gradient(135deg, #111827 0%, #1f2937 50%, #111827 100%)',
        borderColor: '#4b5563',
        hoverBorderColor: '#8b5cf6',
        accentColor: '#a78bfa',
        textColor: '#ffffff',
        secondaryTextColor: '#9ca3af',
        categoryIcon: '',
        glowColor: 'rgba(139, 92, 246, 0.15)',
        focusRingColor: '#8b5cf6',
        cutoutBgColor: '#111827',
        stubTextColor: '#9ca3af',
        dashedBorderColor: 'rgba(75, 85, 99, 0.6)',
        badgeSvg: tierBadges.Standard,
        buttonGradient: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 50%, #7c3aed 100%)',
        buttonTextColor: '#ffffff',
    },
};

/**
 * Get the style configuration for a booking category
 */
export function getTicketCategoryStyle(category: BookingCategoryClass | undefined): TicketCategoryStyle {
    return categoryStyles[category || 'Standard'];
}

/**
 * Get the display label for a booking category
 */
export function getCategoryLabel(category: BookingCategoryClass | undefined): string {
    if (!category || category === 'Standard') {
        return '';
    }
    const style = categoryStyles[category];
    return `${style.categoryIcon} ${category.toUpperCase()} TICKET ${style.categoryIcon}`;
}

/**
 * Check if a category is a premium tier (not Standard)
 */
export function isPremiumCategory(category: BookingCategoryClass | undefined): boolean {
    return category !== undefined && category !== 'Standard';
}
